import { cn } from 'src/lib/utils';
import { ErrorBoundary } from 'src/pages/web/_components/Errors/ErrorBoundary';
import { getCurrentPlatformContext } from 'src/utils/platformDetection';

interface Props {
  id?: string;
  className?: string;
  // Defaults to "on any platform route". Pages outside the platform routes
  // (the error pages) can't tell from the path that they run inside a platform.
  darkBackground?: boolean;
}

export const PageWrapper = ({
  children,
  className,
  id,
  darkBackground = getCurrentPlatformContext() !== 'web',
}: React.PropsWithChildren<Props>) => {
  return (
    <div
      className={cn(
        `
          flex h-full min-h-dvh max-w-none flex-1 flex-col bg-white-darken-3 p-0
          md:px-24 md:py-20
        `,
        {
          'dark:bg-raisin-black': darkBackground,
        },
        className,
      )}
      id={id}
    >
      <ErrorBoundary>{children}</ErrorBoundary>
    </div>
  );
};
